module.exports = __webpack_public_path__ + "static/media/ic_cancel_popup.d94405a2.svg";